import axios from "axios";

const configApi = {
  getConfig: async () => {
    const url = "/conf.json";
    return await axios.get(url);
  },
};

export default configApi;
